import React from "react"
import { Link } from "react-scroll"
import "./Programs.css"
import { programsData } from "../../data/programsData"
import RightArrow from "../../assets/rightArrow.png"

const Programs = () => {
  return (
    <div className="Programs" id="programs">
      {/* header */}
      <div className="programs-header">
        <span className="stroke-text">Explore our</span>
        <span>Programs</span>
        <span className="stroke-text">to Shape you</span>
      </div>

      <div className="program-categories">
        {programsData.map((program,index) => {
          return (
            <div className="category" key={index}>
              {program.image}
              <span>{program.heading}</span>
              <span>{program.details}</span>
              <div className="join-now">
                <Link
                  activeClass="active"
                  to="plans"
                  spy={true}
                  smooth={true}
                  offset={-40}
                  duration={500}
                >
                  <span>Join Now</span>
                  <img src={RightArrow} alt="" />
                </Link>
              </div>
            </div>
          )
        })}
      </div>
    </div>
  )
}

export default Programs
